import { red } from "@ant-design/colors";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import {
  WalletAddressProtocolsWithNetwork,
  WalletAddressStatus,
} from "@lib/types/Billing";
import { Form, Input, Select, Tag } from "antd";
import { FormInstance } from "antd/lib";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props = {
  form: FormInstance<any>;
  loading: boolean;
  walletAddressId?: string;
};

export default function WalletAddressProtocolInput(props: Props) {
  const { loading, form, walletAddressId } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);
  const status = Form.useWatch("status", form);
  const network = Form.useWatch("network", form);

  useEffect(() => {
    form.setFieldValue("protocol", null);

    if (network && WalletAddressProtocolsWithNetwork[network].length === 1) {
      form.setFieldValue(
        "protocol",
        WalletAddressProtocolsWithNetwork[network][0],
      );
    }
  }, [network, form]);

  if (status === WalletAddressStatus.InUse && walletAddressId) {
    return (
      <Form.Item
        name="protocol"
        rules={[createYupSync({ schema: yupSchema })]}
        label={messages["common.walletProtocol"] as string}
      >
        <Input variant="borderless" disabled={true} />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name="protocol"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.walletProtocol"] as string}
    >
      <Select
        placeholder={messages["common.makeYourChoice"] as string}
        disabled={loading || !walletId || !network}
        showSearch
        optionFilterProp="text"
        options={
          !network
            ? []
            : WalletAddressProtocolsWithNetwork[network].map((protocol) => ({
                label: <StyledFlex style={{ gap: 5 }}>{protocol}</StyledFlex>,
                text: protocol,
                value: protocol,
              }))
        }
      >
        {!network && (
          <Select.Option value="disabled" disabled>
            <Tag color={red[6]}>
              <FormattedMessage
                id="common.makeYourChoiceToX"
                values={{ x: messages["common.walletType"] as string }}
              />
            </Tag>
          </Select.Option>
        )}
      </Select>
    </Form.Item>
  );
}
